import { clearHeader } from "@shared/apis"
import { Token } from "@shared/apis/account"

import { getCookies, removeCookies, setCookies } from "./cookies"
import { toTimestamp } from "./date"
import store from "./store"

// 숏폼 비회원 진입처럼 일부 토큰만 내려오는 경우가 있어 전부 선택값으로 받는다.
interface TokenProps extends Partial<Token> {
  scheduleId?: string | undefined
}

function setTokens({
  scheduleId,
  accessToken,
  chattingToken,
  wmsAuthToken,
  vodWmsAuthToken,
  refreshToken,
  createdAt,
}: TokenProps) {
  store.session.set("accessToken", accessToken || "")
  store.session.set("wmsAuthToken", wmsAuthToken || "")
  store.session.set("vodWmsAuthToken", vodWmsAuthToken || "")

  setChattingToken(chattingToken)

  if (scheduleId) {
    store.session.set("scheduleId", scheduleId)
  }

  if (createdAt) {
    store.session.set("signedAt", toTimestamp(createdAt).toString())
  }

  if (refreshToken) {
    setCookies("refreshToken", refreshToken)
  }
}

function removeTokens() {
  store.session.remove("scheduleId")
  store.session.remove("accessToken")
  store.session.remove("chattingToken")
  store.session.remove("wmsAuthToken")
  store.session.remove("vodWmsAuthToken")
  store.session.remove("scheduleId")
  store.session.remove("signedAt")
  store.session.remove("timestamp")

  removeCookies("refreshToken")
  clearHeader()
}

function getSchdueId(): string | undefined | null {
  return store.session.get("scheduleId")
}

function getIsAccessToken() {
  return (
    (store.session.get("accessToken") !== "" &&
      store.session.get("accessToken") !== null &&
      store.session.get("accessToken") !== undefined) ||
    getCookies("accessToken") !== undefined
  )
}

function getIsRefreshToken() {
  return getCookies("refreshToken") !== undefined
}

function getAccessToken() {
  return store.session.get("accessToken") || getCookies("accessToken")
}

function getChattingToken() {
  return store.session.get("chattingToken") || getCookies("chattingToken")
}

function setChattingToken(chattingToken: string | undefined) {
  return store.session.set("chattingToken", chattingToken || "")
}

function getWmsAuthToken() {
  return store.session.get("wmsAuthToken") || getCookies("wmsAuthToken")
}

function getVodWmsAuthToken() {
  return store.session.get("vodWmsAuthToken") || getCookies("vodWmsAuthToken")
}

function getSignedAt() {
  return store.session.get("signedAt")
}

function getUsername() {
  return getCookies("username") ? getCookies("username") : ""
}

function setUsername(username: string) {
  return setCookies("username", username)
}

function removeUsername() {
  removeCookies("username")
}

function getTimestamp() {
  return store.session.get("timestamp")
}

function setTimestamp() {
  const timestamp = new Date().getTime()
  store.session.set("timestamp", timestamp.toString())

  return timestamp
}

export {
  setTokens,
  removeTokens,
  getIsAccessToken,
  getIsRefreshToken,
  getSchdueId,
  getAccessToken,
  getChattingToken,
  setChattingToken,
  getSignedAt,
  getWmsAuthToken,
  getVodWmsAuthToken,
  getUsername,
  setUsername,
  removeUsername,
  getTimestamp,
  setTimestamp,
}
